<div id="editorModeButtons" class="splitToolbarButton toggled" role="radiogroup">
  <pdf-comment-editor [show]="showCommentEditor"></pdf-comment-editor>
  <pdf-editor-signature [show]="showSignatureEditor"></pdf-editor-signature>
  <pdf-highlight-editor [show]="showHighlightEditor"></pdf-highlight-editor>
  <pdf-text-editor [show]="showTextEditor"></pdf-text-editor>
  <pdf-stamp-editor [show]="showStampEditor"></pdf-stamp-editor>
  <pdf-draw-editor [show]="showDrawEditor"></pdf-draw-editor>
</div>